export const MODULE_NAME = 'memberships';

export const Roles = {
    CONTRIBUTOR: 'contributor',
    ACCOUNTANT: 'accountant',
    OWNER: 'owner',
};
